import { BoolEquals, Or, Rule } from '@vendasta/automata';

/*
 * The TristateBool helper is used to support the usecase of true/false/any when the value you are checking against is
 * a boolean. With string list compare, we added the support of a wild card matcher "*" to match on anything. Unfortunately
 * "*" is not an acceptable boolean value, so we can't actually pass that through your json marshalling/unmarshalling. So instead what we can do
 * to support a true/false/any selector is to swap out the rules. Basic BoolEquals for true/false and
 * an Or(BoolEquals(true), BoolEquals(false)) for the any state. Unfortunately this makes it awkward for parsing the rule data
 * in your trigger panel component. So we have this helper to make it easier to convert between the two.
 */

export enum TristateBool {
  ANY = 'any',
  TRUE = 'true',
  FALSE = 'false',
}
export type AllTristateBoolValues = TristateBool.ANY | TristateBool.TRUE | TristateBool.FALSE;

export function getRuleFromTristateBool(variablePath: string, value: AllTristateBoolValues[]): Rule {
  if (!value || value[0] === TristateBool.ANY || value.length !== 1) {
    return new Or([new BoolEquals(variablePath, true), new BoolEquals(variablePath, false)]);
  }
  if (value[0] === TristateBool.TRUE) {
    return new BoolEquals(variablePath, true);
  } else {
    return new BoolEquals(variablePath, false);
  }
}

export function getTristateBoolValueFromList(value: any[]): TristateBool {
  if (!value || value?.length != 1) {
    return TristateBool.ANY;
  }
  if (value[0] === true) {
    return TristateBool.TRUE;
  } else {
    return TristateBool.FALSE;
  }
}
